import { useTranslation } from 'next-i18next'

import { ButtonPrimary } from '~/components/Buttons'
import ResponsiveImage from '~/components/Image/ResponsiveImage'
import ROUTES from '~/shared/constants/routes.const'

const mediaQuery = [{ screen: '(min-width: 280px)', width: '60vw' }]

export default function StatsNotFound({ days }: { days?: number }): React.ReactElement {
  const { t } = useTranslation('statistics')

  return (
    <div className="space-y-3">
      <p className="text-center font-medium text-md text-white">
        {days ? t('you-have-not-visited', { n: days }) : t('you-have-not-visited-all-time')}
      </p>
      <div className="flex items-center justify-center">
        <ResponsiveImage
          alt={t('alt_texts.vcc')}
          height={36}
          imageClassName="h-9 mr-2"
          mediaQuery={mediaQuery}
          srcKey="icons/products/videocrashcourse.png"
        />
        <ButtonPrimary href={ROUTES.BOOTCAMP} size="small">
          {t('got-to-video-courses')}
        </ButtonPrimary>
      </div>
    </div>
  )
}
